<template>
  <div>
    <CModal :show.sync="activeDelete" centered :draggable="false">
      <template slot="header-wrapper">
        <div />
      </template>
      Etes-vous sûr de vouloir supprimer {{activeDeleteName}} ?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeDelete = null">
          Non
        </CButton>
        <CButton color="primary" @click="removeUnsubscribe">Oui</CButton>
      </template>
    </CModal>
    <CModal :show.sync="activeAdd" centered :draggable="false">
      <div class="d-flex flex-column gap-1">
        <h5 class="text-muted">Email(s)</h5>
        <div class="d-flex gap-2 align-items-center">
          <CInput
            class="flex-fill"
            v-model="addEmails"
          />
          <CButton
            color="primary"
            @click="addUnsubscribedEmails"
          >
            Ajouter
          </CButton>
        </div>
        <div class="mt-1">
          <h5 class="text-muted">Alumni à désinscrire</h5>
          <div>
            <div
              class="email-selection-wrapper"
            >
              <div
                class="selection"
                v-for="selection in selectedEmails"
              >
                <span class="text-muted">{{selection}}</span>
                <CButton
                  class="btn delete-btn"
                  color="link"
                  @click="removeEmail(selection)"
                >
                  <em class="fa fa-trash"/>
                </CButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
          <CButton color="primary" @click="unsubEmails">
            Désinscription
          </CButton>
        </template>
    </CModal>
    <div class="d-flex justify-content-end mb-3">
      <CButton
        color="primary"
        @click="activeAdd = true"
      >
        Ajouter
      </CButton>
    </div>
    <tableComponent
      :url="tableUrl"
      :columns="tableColumns"
      :headings="tableHeadings"
      :key="refreshTable"
      :filter-exclude-columns="['actions']"
      :sort-exclude-columns="['actions']"
      :show-top-number-of-records="false"
      :display-columns-selector="false"
    >
      <template slot="actions" slot-scope="{ row }">
        <CButton color="danger" size="sm" @click="activeDelete = row; activeDeleteName = row.email">
          Supprimer
        </CButton>
      </template>
    </tableComponent>
  </div>
</template>

<script>
import { errorMessage } from "@/constants/common";
import {
  UNSUBSCRIBED_USERS_ENDPOINTS,
  UnsubscribedUsersService,
} from "@/services/unsubscribedUsers";

export default {
  name: "UnsubscribedUsers",
  data() {
    return {
      activeDeleteName: null,
      refreshTable: 0,
      tableUrl: UNSUBSCRIBED_USERS_ENDPOINTS.base,
      tableColumns: ["email", { name: "created_at", type: "date" }, "actions"],
      tableHeadings: {
        created_at: "Date création",
      },
      activeDelete: null,
      activeAdd: null,
      addEmails: '',
      selectedEmails: [],
    };
  },
  methods: {
    async unsubEmails() {
      await UnsubscribedUsersService.addUnsubscribed(
        {"emails":  this.selectedEmails}
      );
      this.refreshTable += 1;
      this.activeAdd = null;
      this.selectedEmails = [];
    },
    addUnsubscribedEmails() {
      this.addEmails = this.addEmails.replace(/\s/g, '');
      this.selectedEmails = [...this.selectedEmails, ...this.addEmails.split(';')];
      this.addEmails = '';
    },
    removeEmail(value) {
      const index = this.selectedEmails.indexOf(value);
      if (index === -1) {
        return;
      }
      this.selectedEmails.splice(index, 1);
    },
    async removeUnsubscribe() {
      const { res } = await UnsubscribedUsersService.removeUnsubscribe(
        this.activeDelete._id
      );
      if (res.status === 200) {
        this.activeDelete = null;
        this.refreshTable += 1;
      } else {
        alert(errorMessage);
      }
    },
  },
};
</script>
<style lang="scss">
  .email-selection-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: $gray-100;
  padding: 20px;
  width: 466px;
  max-height: 115px;
  overflow: scroll;
  gap: 10px;

  .delete-btn {
    background-color: white;
    width: 22px;
    height: 22px;
    border: 1px solid $primary;
    padding: 1px 1px;
  }

  .selection {
    display: flex;
    height: 35px;
    justify-content: space-between;
    background-color: white;
    gap: 10px;
    padding: 10px;
    border: 1px solid black;
    align-items: center;
  }

}
</style>
